
import { ButtonHTMLAttributes } from 'react';

interface ButtonProps extends ButtonHTMLAttributes<HTMLButtonElement> {
  variant?: 'primary' | 'secondary';
  fullWidth?: boolean;
  children: React.ReactNode;
}

export default function Button({ 
  variant = 'primary', 
  fullWidth = false, 
  children, 
  className = '',
  disabled,
  ...props 
}: ButtonProps) {
  const baseStyles = `
    px-6 py-3.5 
    min-h-[44px] 
    rounded-lg 
    text-base font-semibold 
    tracking-wide 
    transition-all duration-200 ease-in-out 
    whitespace-nowrap 
    cursor-pointer 
    uppercase
    inline-flex items-center justify-center
    active:scale-[0.98]
  `;
  
  const variants = {
    primary: `
      bg-[#7F9C8B] text-white 
      shadow-[0_2px_8px_rgba(127,156,139,0.25)]
      hover:bg-[#5E7568] hover:shadow-[0_4px_12px_rgba(127,156,139,0.35)]
      disabled:bg-gray-300 disabled:text-gray-500 disabled:shadow-none disabled:cursor-not-allowed disabled:active:scale-100
    `,
    secondary: `
      bg-transparent 
      border-[1.5px] border-[#7F9C8B] 
      text-[#7F9C8B]
      hover:bg-[#DDE6E1] hover:border-[#5E7568] hover:text-[#5E7568]
      disabled:bg-gray-100 disabled:border-gray-300 disabled:text-gray-400 disabled:cursor-not-allowed disabled:active:scale-100
    `
  };

  return (
    <button
      className={`${baseStyles} ${variants[variant]} ${fullWidth ? 'w-full' : ''} ${className}`}
      disabled={disabled}
      {...props}
    >
      {children}
    </button>
  );
}
